import { Button, Icon, Tooltip } from '@nimbus-ds/components';
import { FEATURE_SEARCH_FILTER } from 'App/features';
import { useResponsive } from 'commons/components';
import { ORDERS_SAVED_SEARCH_FILTER } from 'config/upsellFlowSources';
import { useUpsellFlow } from 'domains/Billing/UpsellFlow/hooks';
import { trackingSavedSearchConfigOpen } from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { ReactComponent as QuickfilterIconHigh } from './images/QuickfilterIconHigh.svg';
import { ReactComponent as QuickfilterIconLow } from './images/QuickfilterIconLow.svg';

interface SavedSearchesConfigButtonProps {
  onClick: () => void;
}

export function SavedSearchesConfigButton({
  onClick,
}: Readonly<SavedSearchesConfigButtonProps>) {
  const { isMobile } = useResponsive();
  const t = useTranslationOrders();
  const handleClick = useUpsellFlow({
    title: t('filter.upsell.search'),
    featureKey: FEATURE_SEARCH_FILTER,
    trackingSource: ORDERS_SAVED_SEARCH_FILTER,
    includeCallbackResult: true,
    callback: () => {
      trackingSavedSearchConfigOpen();
      onClick();
    },
  });

  return (
    <Tooltip
      content={t('savedSearches.configModal.title')}
      position="bottom"
      arrow
    >
      <Button
        appearance={isMobile ? 'neutral' : 'transparent'}
        onClick={handleClick}
      >
        <Icon
          source={
            isMobile ? (
              <QuickfilterIconLow
                width="16px"
                height="16px"
                viewBox="0 0 16 16"
                fill="currentColor"
              />
            ) : (
              <QuickfilterIconHigh
                width="16px"
                height="16px"
                viewBox="0 0 16 16"
                fill="currentColor"
              />
            )
          }
        />
      </Button>
    </Tooltip>
  );
}
